import Vue from 'vue';
import Vuex from 'vuex';
import { datePickerConfig } from './store.js';
Vue.use(Vuex);

const URLs = {
  base: process.env.VUE_APP_PARTNER_BASE_URL,
  lineLogin: process.env.VUE_APP_LINE_BIZ_LOGIN_URL,
  api: process.env.VUE_APP_API_VERSION,
  apiPartner: process.env.VUE_APP_PARTNER_API_VERSION,
  getAccessToken: '/login/v1/oauth2/getAccessToken',
  getProfile: process.env.VUE_APP_GET_PROFILE_URL,
  loginApi: '/login/v1/oauth2',
  callback: '/bizLogin/callback.html',
  homepage: '/partner.html',
  news: '#/news',
  category: '#/category'
};

const routes = {
  todayStats: '/stats',
  latestArticles: '/articles/latest',
  latestArticlesByCategory: '/articles/latestByCategory',
  latestArticlesByPartner: '/articles/latestByPartner',
  recommendArticleByContent: '/articles/recommendation',
  verifiedArticles: '/articles/verified',
  govAnnounces: '/search/govAnnounces',
  topTenArticles: '/articles/hottest',
  getSingleArticle: '/articles',
  partnerFollowingArticles: '/partners/followingArticles',
  followingArticleIds: '/partners/followingArticleIds',
  searchArticles: '/search/articles',
  partners: '/partners',
  partnersStats: '/partners/stats',
  govPartners: '/govPartners',
  eduPartners: '/eduPartners',
  banner: '/banner/latest',
  classicArticles: '/classicArticles',
  govOption: '/govOptions',
  getAccessTokenByLiff: '/getAccessTokenByLiff',
  feedbackTypes: '/feedbackTypes',
  postFeedbacks: '/partners/addFeedbacks',
  publicReviewers: '/users/publicReviewers',
  judgements: '/judgements',
  partnerVerified: '/articles/myVerified'
};

const storageKeys = {
  visited: 'visited',
  lastVisit: 'lastVisit',
  token: 'token',
  displayName: 'displayName',
  pictureUrl: 'pictureUrl',
  identity: 'identity',
  id: 'id',
  bannerId: 'bannerId',
  logoutUrl: 'logoutUrl'
};

export default new Vuex.Store({
  state: {
    URLs: URLs,
    routes: routes,
    channelID: process.env.VUE_APP_CHANNEL_ID,
    storageKeys: storageKeys,
    lang: 'zhtw',
    datePickerConfig: datePickerConfig,
    recaptchaSiteKey: '6LeETL8UAAAAAK6dWfXcfFnyiZKCI6PS-L7MqUEY',
    identity: 'partners'
  }
});
